import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_PAYPAL_EXPRESS_TOKEN } from './checkoutQueries';

// To have a working PayPal payment method we need to comment line vendor/magento/module-paypal-graph-ql/Model/Resolver/Store/Url.php:103

const MagentoPayPalButton = ({
    cartId,
    onSuccess,
    onError,
    disabled = false
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [createPayPalToken] = useMutation(CREATE_PAYPAL_EXPRESS_TOKEN);

    const handlePayPalClick = async () => {
        if (disabled) return;

        setIsLoading(true);

        try {
            // Create PayPal Express token through Magento
            const result = await createPayPalToken({
                variables: {
                    cartId,
                    code: 'paypal_express',
                    express_button: true,
                    urls: {
                        return_url: `${window.location.origin}/paypal/return`,
                        cancel_url: `${window.location.origin}/paypal/cancel`
                    }
                }
            });

            const { token, paypal_urls } = result.data.createPaypalExpressToken;

            if (token && paypal_urls?.start) {
                // Redirect to PayPal using Magento's generated URL
                window.location.href = paypal_urls.start;
            } else {
                throw new Error('Failed to create PayPal token');
            }
        } catch (error) {
            console.error('PayPal token creation error:', error);
            setIsLoading(false);

            const errorMessage = error.graphQLErrors?.[0]?.message ||
                error.message ||
                'Failed to initiate PayPal payment';

            onError(new Error(errorMessage));
        }
    };

    return (
        <div className="magento-paypal-container">
            <button
                className="magento-paypal-button"
                onClick={handlePayPalClick}
                disabled={disabled || isLoading}
                style={{
                    background: '#0070ba',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
                    opacity: disabled || isLoading ? '0.6' : '1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    width: '100%',
                    transition: 'background-color 0.2s',
                    minHeight: '48px'
                }}
                onMouseEnter={(e) => {
                    if (!disabled && !isLoading) {
                        e.target.style.backgroundColor = '#005ea6';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!disabled && !isLoading) {
                        e.target.style.backgroundColor = '#0070ba';
                    }
                }}
            >
                {isLoading && (
                    <div
                        style={{
                            width: '16px',
                            height: '16px',
                            border: '2px solid white',
                            borderTop: '2px solid transparent',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}
                    />
                )}
                <span>
          {isLoading ? 'Redirecting to PayPal...' : 'Pay with PayPal'}
        </span>
            </button>

            <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

export default MagentoPayPalButton;